<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="pay-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title dialog-title">确认兑换该道具?</h5>
                    <div class="pay-view">
                        <div class="goods-detail">
                            <div class="goods-wrapper">
                                <div class="goods-pic" v-tips="'1'"><game-item :locked="true" :id="'1'" :num="1"></game-item></div>
                            </div>
                            
                            <div class="item-name">金鸡币</div>
                        </div>                        
                    </div>

                                                  
                    <div class="calc-view">
                        <div class="amount calc-item">
                            <div class="calc-label"><div class="label-amount">购买数量：</div></div>
                            <el-input-number v-model="value" 
                                :min="1" :max="999"
                                :step=1
                                step-strictly
                            ></el-input-number>
                        </div>
                        <div class="total calc-item">
                            <div class="calc-label"><div class="label-cost">总消耗：</div></div>
                            <span class="price"><b>梦三币*{{ value * cost }}</b></span>
                        </div>
                    </div>

                    <div class="u-ctrl">
                        <div class="u-btn cancel" @click="closeModal"></div>
                        <div class="u-btn ok" @click="apply"></div>                       
                    </div>
                    
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.pay-modal{
    position: relative;
    width: 667px;
    height: 521px;
    background-image: url(~@/assets/images/modal/bg-modal_lg2.png); 
}

.title{
    width: 155px;
    height: 33px;
    margin: 0 auto 40px;
    font-weight: 400;
    font-size: 0;
    color: transparent;
    text-align: center;
    background-image: url(~@/assets/images/modal/title-buy_token.png);  
}

.pay-view{
    margin-bottom: 30px;
    padding: 20px 0;
    background-color: #ededec;
}

.pay-view p{
    padding: 0 20px;
    line-height: 1.8;
}

.pay-view b{
    /* color: #fe5a1e; */
}

.goods-detail{
    .goods-wrapper{
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 100px;
        height: 100px;
        margin: 0 auto;
        background-image: url(~@/assets/images/modal/bg-item.png);
        background-color: transparent;
        border: none;
    }

    .goods-pic{
        width: 69px;
        height: 69px;
    }
}

.item-name{
    margin-top: 10px;
    color: #8d684b;
    text-align: center;
}

.calc-item{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 10px;
    color: #696560;
    font-size: 22px;
    font-weight: 700;
    // justify-content: center;

    .price{
        b{
            color: #d33d27;
        }
    }
}

.calc-item.amount{
    width: 524px;
    margin: 0 auto 16px;
    padding: 7px 0;
    border: 1px solid #f6d4c9;
    border-radius: 30px;
    font-size: 22px;
    font-weight: 700;
    color: #6d645a;    
}

.warn{
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%; 
    margin-top: 15px;
    font-size: 20px;
    color: #c2393f;
    text-align: center;
    vertical-align: text-top;
}

.i-warn{
    display: inline-block;
    width: 21px;
    height: 21px;
    margin: 0 5px;
    background-image: url(~@/assets/images/modal/icon-warn.png);
    vertical-align: sub;
}

.u-ctrl{
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    margin-top: 36px;
}

.u-ctrl .u-btn.ok{
    width: 246px;
    height: 65px;
    margin: 0 10px;
    background-image: url(~@/assets/images/modal/btn-submit.png);    
}

.u-ctrl .u-btn.cancel{
    width: 246px;
    height: 65px;
    margin: 0 10px;
    background-image: url(~@/assets/images/modal/btn-cancel.png);    
}

</style>

<style>
.el-slider__runway{
    height: 10px;
    background-color: #e3c8a8;
    /* box-shadow: 0 0 3px 3px rgba(184, 122, 83, .5); */
}

.el-slider__bar{
    height: 8px;
    background: linear-gradient(to right, #ffa65f, #d75026);
}

.el-slider__button{
    width: 47px;
    height: 47px;
    border: none;
    background-image: url(~@/assets/images/modal/icon-circle.png);
    background-color: transparent;
}

.el-tooltip__popper.is-dark{
    font-size: 30px;
    color: transparent;
    font-weight: 700;
    background-color: transparent;
}

.el-tooltip__popper .popper__arrow{
    /* width: 12px;
    height: 21px;
    bottom: -10px;
    background-image: url(~@/assets/images/icon-arrow.png); 
    border: none; */
    display: none;
}

.el-tooltip__popper .popper__arrow::after{
    display: none;
}

.el-input{
    /* width: 345px; */
}

.el-input__inner{   
    background-color: transparent;
    border: none;
    font-size: 22px;
    color: #e05b4a;
}

.el-input-number__decrease, .el-input-number__increase{
    top: 6px;
    width: 31px;
    height: 31px;
    border: none;
}

.el-input-number__decrease i, .el-input-number__increase i{
    display: none;
}

.el-input-number__decrease{
    background: url(~@/assets/images/modal/btn-minus.png); 
}

.el-input-number__increase{
    background: url(~@/assets/images/modal/btn-plus.png); 
}

.el-tooltip__popper{
    /* padding-top: 20px; */
    transform: translateY(20px);
}
</style>

<script>
import {
    apiCoinBuy,
} from '@/api/index';

export default {
    data () {
        return {
            visible : false,
            gid : '2',
            giftName : '----',
            cost : 1,
            num : 1,
            score : 0,
            text : '',
            item : {},
            value : 1,
            max: 999,
            message : {
                '1209' : '请先购买沙场争霸通行证',
            }
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    mounted(){
        this.max = this.item.max == -1 ? 999 : this.item.max - this.item.orderNum;
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },         
        apply(){

            apiCoinBuy({
                num : this.value,
            }).then(
                res => {
                    this.destroyElement();
                    this.$msg_modal('购买成功'); 
                    this.$update_evt();
                    
                    //todo
                },
                rej => {
                    this.destroyElement();
                    let type = rej.code == 416 ? 2 : 1;
                    this.$msg_modal({text : this.message[rej.code] || rej.message , type : type});                  
                },
            )
        },        
    },    
}
</script>